import ArticlesSectionComponent from 'components/Sections/RelatedArticlesVariations/ArticlesSectionComponent';
import React from 'react';
import HelpArticleTile from 'components/Tiles/HelpArticleTile';
import { TaggedHelpArticle } from 'model/HelpArticle';
import { ComponentProps } from 'lib/component-props';
import styles from './RelatedHelpArticleSection.module.scss';

type Props = ComponentProps & {
  id: string;
  className: string;
  articles: Array<TaggedHelpArticle>;
  baseUrl: string;
  title: string;
};

const RelatedHelpArticlesSection = ({
  articles,
  rendering,
  className,
  id,
  baseUrl,
  title,
}: Props) => {
  return (
    <div className={`${className} background-digital-light-grey`} id={id}>
      <ArticlesSectionComponent
        sectionTitle={title}
        rendering={rendering}
        articles={articles}
        sliderCardComponent={HelpArticleTile}
        baseUrl={baseUrl}
        className={styles['related-help-article']}
      />
    </div>
  );
};

export default RelatedHelpArticlesSection;
